module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [(_vm.loading) ? _c('p', [_vm._v("Loading...")]) : _c('section', {
    staticClass: "modal-card-body d-block br-1"
  }, [_c('header', {
    staticClass: "d-flex align-items-center pb-3 space-between"
  }, [_c('h2', {
    staticClass: "fs-8"
  }, [_vm._v("Select Tag")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('section', [_vm._l((_vm.searchResults), function(tag) {
    return _c('span', {
      staticClass: "tag rubric-tag",
      class: {
        'private-tag': tag.group_tag
      },
      style: ({
        'background-color': '#' + tag.color
      })
    }, [_c('a', {
      staticClass: "text",
      on: {
        "click": function($event) {
          _vm.selectTag(tag.id)
        }
      }
    }, [_vm._v(_vm._s(tag.title))])])
  }), _vm._v(" "), (_vm.searchResults.length == 0) ? _c('p', [_vm._v("No existing tags match "), _c('strong', [_vm._v(_vm._s(this.query))]), _vm._v(". Create a new one!")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center pb-3 space-between"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "input is-medium",
    attrs: {
      "placeholder": "New Tag"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "disabled": _vm.query === '',
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.createTag()
      }
    }
  }, [_vm._v("\n            Create\n        ")])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-3fb7e5a2"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddTagModal.vue
// module id = 1014
// module chunks = 0